import { render, staticRenderFns } from "./popoverForm.vue?vue&type=template&id=37ca5a32&scoped=true"
import script from "./popoverForm.vue?vue&type=script&lang=js"
export * from "./popoverForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37ca5a32",
  null
  
)

/* custom blocks */
import block0 from "./popoverForm.vue?vue&type=custom&index=0&blockType=vue-filename-injector"
if (typeof block0 === 'function') block0(component)

export default component.exports